import styled from "styled-components";
import { colors } from "../../styles/colors";

export const ButtonWrapper = styled.div`
position: absolute;
bottom: 0;
    width: 100%;
    padding: 10px 25px 15px 25px;
z-index: 1001;
background-color: ${colors.black};
`